export default __webpack_public_path__ + "static/media/logo3.f1e2eac1.png";